import { H1 } from '@atoms/Typographies';
import Head from '@organisms/Heads/Head';
import CommonTemplate from '@templates/Common';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Prop = {
    title?: string;
    message?: string | ReactNode;
};

const Page404 = (prop: Prop) => {
    const title = prop.title || 'Error';
    const message = prop.message || 'エラーが発生しました';
    return (
        <CommonTemplate>
            <Head title="Error" />

            <Page404WithStyled>
                <HeadingWithStyled className="mb-4">
                    <H1>{title}</H1>
                </HeadingWithStyled>
                <ContentWithStyled>
                    <AnnotationWithStyled>
                        {message}
                    </AnnotationWithStyled>
                </ContentWithStyled>
            </Page404WithStyled>
        </CommonTemplate>
    );
};

const Page404WithStyled = styled.div`
`
const HeadingWithStyled = styled.div`
`
const ContentWithStyled = styled.div`
    padding: 0 10px;
`
const AnnotationWithStyled = styled.div`
    height: calc(100vh - 200px);
`

export default Page404;